// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"Description_FormTitle_1jvXc","box":"Description_box_wIjSq"};